import React from 'react'
import TableWidget2 from './TableWidget2'
import browsers from '../json/browsers.json'

const SampleTableWidget2 = () => <TableWidget2 items={browsers} />

export default SampleTableWidget2



// WEBPACK FOOTER //
// ./src/table-widgets/SampleTableWidget2.js